/**
 * SensitivityBadge — color-coded chip for a doc's sensitivity tier.
 *
 *   standard     — neutral (gray)
 *   confidential — warning (amber)
 *   proprietary  — destructive (red)
 *
 * Matches the OQ-D.2 visibility hierarchy: as you move up the
 * spectrum, fewer roles can see the doc. The red chip on a
 * proprietary row reminds members it's invisible to viewers.
 */

import type { VaultDocumentSensitivityDto } from '@/lib/api';

interface SensitivityBadgeProps {
  sensitivity: VaultDocumentSensitivityDto;
  className?: string;
}

const STYLES: Record<VaultDocumentSensitivityDto, string> = {
  standard: 'bg-muted text-muted-foreground border border-border',
  confidential: 'bg-amber-100 text-amber-900 border border-amber-300',
  proprietary: 'bg-red-100 text-red-900 border border-red-300',
};

const LABELS: Record<VaultDocumentSensitivityDto, string> = {
  standard: 'Standard',
  confidential: 'Confidential',
  proprietary: 'Proprietary',
};

export function SensitivityBadge({ sensitivity, className = '' }: SensitivityBadgeProps) {
  return (
    <span
      className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${STYLES[sensitivity]} ${className}`}
    >
      {LABELS[sensitivity]}
    </span>
  );
}
